import { Pagination } from '../../../../../productCategories/Pagination';
import StaySmallSmallFilter from './StaySmallSmallFilter';
import { StaySmallSmallHeroText } from './StaySmallSmallHeroText';
import { StaySmallSmallProperties } from './StaySmallSmallProperties';

export const StaySmallSmall = () => {
  return (
    <>
      <StaySmallSmallFilter />
      <StaySmallSmallHeroText />
      <StaySmallSmallProperties />
      <div className="mb-20 mt-10">
        <Pagination />
      </div>
    </>
  );
};
